/* Kaart: maten en rand uit de merktokens (packages/ui-core/src/brand.css) via de app
   (apps/web/src/design.css); de terugval is dezelfde waarde. */
.card {
  max-width: 440px;
  margin: 0 auto var(--b-space-16, 16px);
  padding: var(--card-pad, 16px);
  border-radius: var(--radius-card, 16px);
  background: var(--surface-panel);
  box-shadow: var(--card-edge, 0 0 0 1px var(--border-subtle));
}

.wide {
  max-width: none;
  margin-left: 0;
  margin-right: 0;
}

.flush {
  padding: 0;
  overflow: hidden;
}

.flush .head {
  padding: var(--b-space-12, 12px) var(--card-pad, 16px) 0;
}

.quiet {
  background: var(--surface-sunken);
  box-shadow: none;
}

.head {
  display: flex;
  align-items: center;
  gap: var(--b-space-12, 12px);
  min-height: var(--b-touch, 44px);
  margin-bottom: var(--b-space-8, 8px);
}

.headText {
  flex: 1 1 auto;
  min-width: 0;
}

.actions {
  flex: 0 0 auto;
  display: flex;
  gap: var(--b-space-8, 8px);
}

.count {
  flex: 0 0 auto;
  color: var(--text-muted);
  font-size: var(--b-text-small);
  font-weight: 600;
}

.title {
  margin: 0;
  font-size: var(--fs-page);
  font-weight: 600;
  line-height: var(--line-tight);
  letter-spacing: -0.01em;
}

.title2 {
  margin: 0;
  font-size: var(--b-text-lead);
  font-weight: var(--b-weight-strong, 600);
  line-height: var(--b-line-snug, 1.3);
}

.subtitle {
  margin: var(--b-space-4, 4px) 0 0;
  color: var(--text-muted);
  font-size: var(--b-text-small);
}

/* "+n meer": een tekstknop onderaan, tikdoel 44 px, in het accent. */
.more {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: var(--b-touch, 44px);
  margin-top: var(--b-space-4, 4px);
  padding: 0;
  border: 0;
  border-top: 1px solid var(--border-subtle);
  background: transparent;
  color: var(--accent);
  font: inherit;
  font-size: var(--b-text-small);
  font-weight: 600;
  text-align: start;
  text-decoration: none;
  cursor: pointer;
}

.flush .more {
  padding: 0 var(--card-pad, 16px);
}

.more:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: -3px;
}
